import { z } from 'zod';
import { REPORT_CATEGORIES, REPORT_STATUSES } from '../enums';
import { zDate, zId } from './common';

export const MessageBody = z.object({ tenancyId: zId, text: z.string().trim().min(1).max(5000), fileIds: z.array(zId).max(10).default([]), refCostItemId: zId.optional() });
export const TenantMessageBody = MessageBody;
export const TenantReportBody = z.object({ tenancyId: zId, category: z.enum(REPORT_CATEGORIES), text: z.string().trim().min(3).max(5000), photoIds: z.array(zId).max(10).default([]) });
export const UpdateReportBody = z.object({ status: z.enum(REPORT_STATUSES) });
export const TenantReadingBody = z.object({ tenancyId: zId, meterId: zId, date: zDate, value: z.number().min(0), photoFileId: zId.optional(), aiValue: z.number().optional() });
export const ReadNotificationsBody = z.object({ ids: z.array(zId).optional(), all: z.boolean().default(false) });
/**
 * § 312k BGB Kündigungsbutton (web `/kuendigen`, no login): identifies the contract by the account e-mail (optionally
 * name and Kundennummer), ordinary = to the next possible date (end of the running term), extraordinary needs a reason.
 * `date` = desired end, null/absent = nächstmöglicher Zeitpunkt. `website` is a honeypot.
 */
export const CancellationBody = z
  .object({
    email: z.string().trim().email().max(200),
    name: z.string().trim().max(120).optional(),
    accountRef: z.string().trim().max(60).optional(),
    kind: z.enum(['ordinary', 'extraordinary']).default('ordinary'),
    reason: z.string().trim().max(2000).optional(),
    date: zDate.nullable().optional(),
    website: z.string().max(200).optional(),
  })
  .refine((b) => b.kind !== 'extraordinary' || (b.reason ?? '').length >= 3, { path: ['reason'], message: 'Bitte nenn den Grund für die außerordentliche Kündigung.' });
/** Public contact form on the landing (no auth). `website` is a honeypot, `elapsedMs` the fill time. */
export const ContactBody = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.string().email().max(200),
  topic: z.enum(['frage', 'demo', 'support', 'presse']).default('frage'),
  message: z.string().trim().min(10).max(5000),
  website: z.string().max(200).optional(),
  elapsedMs: z.number().int().min(0).max(86_400_000).optional(),
});
